import { fetchPromoCodeAboutApi } from 'api/promoCode/fetchPromoCodeAboutApi'

export const FETCH_PROMO_CODE_ABOUT = 'FETCH_PROMO_CODE_ABOUT' as const

export const fetchPromoCodeAboutAction = (promoCode: string) => ({
  type: FETCH_PROMO_CODE_ABOUT,
  promise: () => fetchPromoCodeAboutApi(promoCode),
})
